import { Button, Input, InputAdornment, Tooltip } from '@mui/material';
import { IFirstMile } from '../index';
import { Line } from '../styles';
import UndoIcon from '@mui/icons-material/Undo';
import DeleteIcon from '@mui/icons-material/Delete';
import { newMoneyWithNegative, newMoney } from 'utils/newMoney';
import dayjs from 'dayjs';

interface FormTableLineProps {
  element: IFirstMile;
  onEditField: (id: number, field: keyof IFirstMile, value: any) => void;
  onRollback: (id: number) => void;
  onDelete: (id: number) => void;
  isEdited: boolean;
  isMarkedForDeletion: boolean;
  hasChanges: boolean;
}

export function FormTableLine({ element, onEditField, onRollback, onDelete, isEdited, isMarkedForDeletion, hasChanges }: FormTableLineProps) {
  const handleChange = (field: keyof IFirstMile, value: any) => {
    onEditField(element.id, field, value);
  };

  const total = element.leaderCommission + element.vehicleCost + element.costAdjustment;

  const getRowStyle = () => {
    if (isMarkedForDeletion) {
      return {
        background: '#FFEBEE',
        transition: 'background 0.2s, border 0.2s',
      };
    }
    if (isEdited) {
      return {
        background: '#E8F2D2',
        transition: 'background 0.2s, border 0.2s',
      };
    }
    return {
      transition: 'background 0.2s, border 0.2s',
    };
  };

  return (
    <Line
      className="bodyLine"
      style={getRowStyle()}
    >
      <td style={{ textAlign: 'left', paddingLeft: '29px' }}>{`${element?.vehicle?.driver?.name || 'Não informado'} ${element?.vehicle?.driver?.surname || ''}`}</td>
      <td style={{ textAlign: 'center' }}>{dayjs(element?.deliveryDate).format('DD/MM/YYYY') || 'Não informado'}</td>
      <td>{element?.vehicle?.licensePlate || 'Não informado'}</td>
      <td>{element?.transshipPoint?.name || 'Não informado'}</td>
      <td>{element?.leaderCommission ? `R$ ${newMoneyWithNegative.apply(element.leaderCommission.toString())}` : 'Não informado'}</td>
      <td>{element?.vehicleCost ? `R$ ${newMoney.apply(element.vehicleCost.toString())}` : 'Não informado'}</td>
      <td onClick={(e: any) => e.target?.children[0]?.focus()}>
        <div className="boxAmount">
          <Input
            type="text"
            value={newMoneyWithNegative.apply(element.costAdjustment)}
            onChange={e => handleChange('costAdjustment', newMoneyWithNegative.clean(e.target.value))}
            onFocus={e => e.target.select()}
            inputProps={{
              style: { textAlign: 'center' },
              inputMode: 'decimal',
              pattern: '^-?[0-9,]*',
            }}
            startAdornment={<InputAdornment position="start" sx={{ padding: 0.5 }}>R$</InputAdornment>}
            sx={{
              width: { xs: 100, sm: 120 },
              height: 48,
              background: '#F7F7F7',
              fontSize: { xs: '0.95rem', sm: '1rem' },
              fontFamily: 'inherit',
              '& input': {
                padding: 0,
                height: 48,
                boxSizing: 'border-box',
              },
            }}
          />
        </div>
      </td>
      <td>R$ {newMoneyWithNegative.apply(total)}</td>
      <td style={{ textAlign: 'center' }}>
        <Tooltip title={isMarkedForDeletion ? "Item marcado para ser deletado" : "Marcar para deletar"}>
          <span>
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={() => !isMarkedForDeletion && onDelete(element.id)}
              disabled={isMarkedForDeletion}
                            style={{
                minWidth: 32,
                padding: 4,
                borderRadius: 20,
                opacity: isMarkedForDeletion ? 0.5 : 1,
                cursor: isMarkedForDeletion ? 'not-allowed' : 'pointer'
              }}
            >
              <DeleteIcon fontSize="small" />
            </Button>
          </span>
        </Tooltip>
      </td>
      <td style={{ textAlign: 'center' }}>
        {hasChanges && (
          <span style={{ display: 'inline-flex', alignItems: 'center' }}>
            <Tooltip title="Reverter alterações">
              <Button
                variant="outlined"
                color="warning"
                size="small"
                onClick={() => onRollback(element.id)}
                style={{ minWidth: 32, padding: 4, borderRadius: 20 }}
            >
              <UndoIcon fontSize="small" />
            </Button>
            </Tooltip>
          </span>
        )}
      </td>
    </Line>
  );
}
